import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';

const CustomTabs = ({ defaultActiveKey, id, tabs, variant }) => {

  return (
    <Tabs variant={variant || 'tabs'} defaultActiveKey={defaultActiveKey} id={id}>
      {tabs.map((tab, index) => (
        <Tab disabled={tab.disabled} key={index} eventKey={tab.eventKey} title={tab.title}>
          {tab.content}
        </Tab>
      ))}
    </Tabs>
  )
}

export default CustomTabs;